import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertBox } from '@/common/AlertBox';
import { InfoSectionContainer } from '@/common/InfoSection';
import { TabsBar } from '@/common/TabsBar';
import { WBSButton } from '@/common/WBSButton';
import { FormTitle, PageContent, PageHeader } from '@/settings/settingsStyles';
import { getMemberSettingsTabs } from '@/settings/tabData';
import { Title } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/settings/export',
)({
  component: ExportDataRoute,
});

function ExportDataRoute() {
  const { t } = useTranslation();
  const [exportOptions, _setExportOptions] = useState({
    profile: true,
    courses: true,
    grades: true,
    messages: false,
    activity: false,
  });
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  // TODO: Set up loading state
  const [_isExporting, setIsExporting] = useState(false);

  const handleExportData = async () => {
    setIsExporting(true);
    console.log('Exporting data:', exportOptions);
    // TODO: Add actual API call to export data

    // Simulate export process
    setTimeout(() => {
      setIsExporting(false);
      setShowSuccessAlert(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 2000);
  };

  return (
    <PageContent>
      {showSuccessAlert && (
        <AlertBox variant="success">
          {/* Translation Needed */}
          Your data export has been requested. You will receive an email with a
          download link shortly.
        </AlertBox>
      )}
      <PageHeader>
        {/* Translation Needed */}
        <Title>Account Settings</Title>
      </PageHeader>

      <div style={{ marginBottom: 11 }}>
        <TabsBar
          tabs={getMemberSettingsTabs(t)}
          base={`/members/${Route.useParams().memberId}/settings`}
          selected="/export"
        />
      </div>
      <InfoSectionContainer>
        <FormTitle>{t('wbs.request-an-export-of')}</FormTitle>
        <AlertBox variant="info">
          {/* Translation Needed */}
          You may download a copy of all data you have created on this platform.
          Click the button below to start a new request. An email will be sent
          to you to verify the request. Then the site admin will review your
          request and if approved, a zip file will be generated and emailed to
          you.
        </AlertBox>
        <WBSButton
          wide
          onClick={handleExportData}
          style={{ margin: '22px 0 19px 0' }}
        >
          {/* Translation Needed */}
          Request Data Export
        </WBSButton>
      </InfoSectionContainer>
    </PageContent>
  );
}
